module.exports = __webpack_public_path__ + "media/images/app/visitors/how-it-works/why_mobile-0e294437fb72858ceaf670bd288252e1.webp";